export default __webpack_public_path__ + "static/media/BuoyancyImg.48035dae.jpg";